// extracted by mini-css-extract-plugin
export default {"container":"DW-z","title":"EW-z","link":"FW-z"};